import React, { Component } from 'react'
import { PageContainer } from '@toolpad/core/PageContainer'
import AssignProcessTable from '../../../components/admin_portal/assigntoprocess/AssignProcessTable'
import CreateAssigntoProcess from '../../../components/admin_portal/assigntoprocess/CreateAssigntoProcess'
import AssignProcessPageToolbar from '../../../components/admin_portal/assigntoprocess/AssignProcessPageToolbar'
import { connect } from 'react-redux';
import {
  get_assign_process_list,
  create_assign_process,
  update_assign_process,
  activate_deactivate_assign_process,
  get_assign_process_details,
  setAssignProcessModalOpen,
  setAssignProcessPage,
  setAction,
  setId,
  setStatus,
  setSearchQuery,
  get_sidebar_menu_list
} from '../../../store/assigntoprocess/assignprocessSlice';
import { get_company_list } from '../../../store/company/companySlice';
import { get_process_list } from '../../../store/process/processSlice';
import { get_stage_list } from '../../../store/stage/stageSlice';

export class AssignProcessContainer extends Component {

  componentDidMount() {
    this.props.get_assign_process_list({
      page: this.props.page + 1,
      limit: 10,
      qn: this.props.search_query,
      qs: this.props.selected_status
    });
    this.props.get_company_list({ page: 1, limit: 100 }); // Fetch standard lists
    this.props.get_process_list({ page: 1, limit: 100 });
    this.props.get_stage_list({ page: 1, limit: 100 });
    this.props.get_sidebar_menu_list();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.page !== this.props.page ||
      prevProps.search_query !== this.props.search_query ||
      prevProps.selected_status !== this.props.selected_status) {
      this.props.get_assign_process_list({
        page: this.props.page + 1,
        limit: 10,
        qn: this.props.search_query,
        qs: this.props.selected_status
      });
    }
  }

  handleAssignProcessModal = (newVal, c_action) => {
    this.props.setAssignProcessModalOpen(newVal);
    this.props.setAction(c_action)
  }

  handleAssignProcessUpdateModal = async (newVal, c_action, assign_process_id) => {
    let res = await this.props.get_assign_process_details(assign_process_id)
    if (res && !res.error) {
      this.props.setAssignProcessModalOpen(newVal);
      this.props.setAction(c_action)
      this.props.setId(assign_process_id)
    }
  };

  handleAssignProcessSubmit = async (payload) => {
    let res = await this.props.create_assign_process(payload);
    if (res && !res.error) {
      this.props.get_assign_process_list({
        page: this.props.page + 1,
        limit: 10,
        qn: this.props.search_query,
        qs: this.props.selected_status
      });
    }
    return res;
  };

  handleAssignProcessUpdate = async (payload) => {
    let res = await this.props.update_assign_process(payload);
    if (res && !res.error) {
      this.props.get_assign_process_list({
        page: this.props.page + 1,
        limit: 10,
        qn: this.props.search_query,
        qs: this.props.selected_status
      });
    }
    return res;
  };

  handleActivateDeactivateAssignProcess = async (payload) => {
    let res = await this.props.activate_deactivate_assign_process(payload);
    if (res && !res.error) {
      this.props.get_assign_process_list({
        page: this.props.page + 1,
        limit: 10,
        qn: this.props.search_query,
        qs: this.props.selected_status
      });
    }
    return res;
  };


  render() {
    const {
      is_assign_process_modal_open,
      common_loading,
      total_assign_process_count,
      page,
      c_action,
      assign_process_id,
      selected_data,
      setAssignProcessPage,
      setSearchQuery,
      setStatus,
      company_list,
      process_list,
      stage_list,
      sidebar_menu_list
    } = this.props;
    return (
      <PageContainer maxWidth='xl' slots={{
        toolbar: AssignProcessPageToolbar,
      }}
        slotProps={{
          toolbar: {
            setSearchQuery: setSearchQuery,
            setStatus: setStatus,
            handleAssignProcessModal: this.handleAssignProcessModal
          }
        }}
        title={""}
        sx={{
          '& .css-lc31tn > .MuiTypography-h4': {
            fontSize: '14px',
            alignSelf: { md: 'center', xs: 'flex-start' },
          },
          '& .css-lc31tn': {
            bgcolor: theme => theme.palette.grey[200],
            px: 1.5,
            py: 0.1,
            borderRadius: '10px',
            my: 1.5,
            flexDirection: { md: 'row', xs: 'column' },
            alignItems: { md: 'unset', xs: 'flex-start' }
          },
          '& .css-1hwxlk6': {
            width: { md: 'unset', xs: '100%' },
            flexDirection: { md: 'row', xs: 'column' },
            marginLeft: { md: 'auto', xs: 'unset!important' }
          },
        }}>
        <AssignProcessTable
          total_count={total_assign_process_count}
          is_loading={common_loading}
          page={page}
          is_modal_open={is_assign_process_modal_open}
          handleUpdateModal={this.handleAssignProcessUpdateModal}
          handleActivateDeactivate={this.handleActivateDeactivateAssignProcess}
          setPage={setAssignProcessPage}
          data={this.props.assign_process_list}
        />
        <CreateAssigntoProcess
          is_modal_open={is_assign_process_modal_open}
          handleModal={this.handleAssignProcessModal}
          handleSubmit={this.handleAssignProcessSubmit}
          handleUpdate={this.handleAssignProcessUpdate}
          is_loading={common_loading}
          c_action={c_action}
          assign_process_id={assign_process_id}
          selected_data={selected_data}
          company_list={company_list}
          process_list={process_list}
          stage_list={stage_list}
          sidebar_menu_list={sidebar_menu_list}
          existing_assignments={this.props.assign_process_list}
        />
      </PageContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  is_assign_process_modal_open: state.assign_process.is_assign_process_modal_open,
  common_loading: state.assign_process.common_loading,
  total_assign_process_count: state.assign_process.total_assign_process_count,
  page: state.assign_process.page,
  c_action: state.assign_process.c_action,
  assign_process_id: state.assign_process.assign_process_id,
  selected_data: state.assign_process.selected_data,
  search_query: state.assign_process.search_query,
  selected_status: state.assign_process.selected_status,
  assign_process_list: state.assign_process.assign_process_list,
  company_list: state.company.company_list,
  process_list: state.process.process_list,
  stage_list: state.stage.stage_list,
  sidebar_menu_list: state.assign_process.sidebar_menu_list
});

const mapDispatchToProps = {
  get_assign_process_list,
  create_assign_process,
  update_assign_process,
  activate_deactivate_assign_process,
  get_assign_process_details,
  setAssignProcessModalOpen,
  setAssignProcessPage,
  setAction,
  setId,
  setStatus,
  setSearchQuery,
  get_company_list,
  get_process_list,
  get_stage_list,
  get_sidebar_menu_list
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignProcessContainer);